'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import privacyPolicyTemplate from '../../directives/privacyPolicy/privacyPolicyContent.html';

var LoginController = function () {
    function LoginController($scope, ApiUser, $state, localStorageService, $ionicLoading, $ionicNavBarDelegate, $ionicPopup, $rootScope, ApiNotifications, digiCert, MessageBox, ApiAuthentication, $ionicModal, $ionicHistory, $cordovaNetwork, ApiDashboard) {
        _classCallCheck(this, LoginController);

        this.ApiUser = ApiUser;
        this.$scope = $scope;
        this.$state = $state;
        this.localStorageService = localStorageService;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$rootScope = $rootScope;
        this.$ionicNavBarDelegate = $ionicNavBarDelegate;
        this.ApiNotifications = ApiNotifications;
        this.digiCert = digiCert;
        this.MessageBox = MessageBox;
        this.ApiAuthentication = ApiAuthentication;
        this.$ionicModal = $ionicModal;
        this.$ionicHistory = $ionicHistory;
        this.$cordovaNetwork = $cordovaNetwork;
        this.ApiDashboard = ApiDashboard;
        // this.privacyPolicyModal = $ionicModal.fromTemplate(privacyPolicyTemplate, { scope: $scope });
        this.user = {};
        this.isToastVisible = true;
    }

    _createClass(LoginController, [{
        key: 'init',
        value: function init() {
            this.localStorageService.remove('token');
            this.localStorageService.remove('filter');
            this.localStorageService.remove('cart');
            this.ApiDashboard.isStartupDisplayed = false;
            this.$rootScope.$broadcast('cartChanged', { count: 0 });

            var username = this.localStorageService.get('username');

            if (username) {
                this.user.username = username;
                this.rememberUser = true;
            } else {
                this.rememberUser = false;
            }

            this.$rootScope.isLoggedIn = false;
            this.digiCert.loadCertificate();
        }
    }, {
        key: 'login',
        value: function login(form) {
            var _this = this;

            if (window.cordova && this.$cordovaNetwork.isOffline()) {
                this.$ionicPopup.alert({
                    title: '<b>Offline</b>',
                    template: 'advinda needs internet connection and cannot run offline',
                    okType: 'button-picton-blue'
                });
                return;
            }
            // this.MessageBox.hideToaster();
            var user = this.user;
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
                animation: 'fade-in',
                delay: 500
            });

            this.ApiAuthentication.loginUser(user.username, user.password).then(function (res) {
                if (_this.rememberUser === false) {
                    _this.localStorageService.remove('username');
                    _this.user.username = undefined;
                    _this.user.password = undefined;
                    form.$setValidity('loginForm.emaishowToastl.$error.email', true);
                    form.$setPristine();
                    form.$setUntouched();
                } else {
                    _this.localStorageService.set('username', _this.user.username);
                }

                if (res !== undefined) {
                    _this.$ionicLoading.hide();
                    _this.localStorageService.set('token', res.token);
                    _this.localStorageService.set('notAuthorized', false);
                    _this.$rootScope.isLoggedIn = true;
                    _this.checkIfStartupWizardNeeded();
                } else {
                    _this.localStorageService.remove('token');
                }
            }).then(function () {
                if (_this.localStorageService.get('token')) {
                    _this.ApiUser.getUser().then(function (res) {
                        if (typeof res != 'undefined') {
                            _this.$rootScope.user = res;
                        }
                    }).then(function () {
                        if (_this.$rootScope.user) {
                            _this.ApiNotifications.getNotifications().then(function (res) {
                                _this.$rootScope.notificationCount = res;
                            });
                        }
                    });
                    if (window.Stripe && window.Stripe.isDummyStripe) {
                        delete window.Stripe;
                        window.location.reload();
                    }
                }
            });
        }
    }, {
        key: 'checkIfStartupWizardNeeded',
        value: function checkIfStartupWizardNeeded() {
            var _this2 = this;

            this.ApiUser.getUser().then(function (res) {
                if (!res) {
                    _this2.$state.go('login');
                    return;
                }
                res.showHelp = !!res.showHelp;
                if (res.showHelp) {
                    if (_this2.$rootScope.isMobileView) {
                        _this2.$state.go('home', { showHelp: true }, { reload: true });
                    } else {
                        _this2.$state.go('selectionsAllPurchasable', { showHelp: true, redirectedFromLogin: true }, { reload: true });
                    }
                    _this2.$ionicHistory.nextViewOptions({
                        disableBack: false,
                        historyRoot: true
                    });
                } else {
                    _this2.$state.go('home', {}, { reload: true });
                }
            });
        }
    }, {
        key: 'showToast',
        value: function showToast() {
            this.isToastVisible = true;
        }
    }]);

    return LoginController;
}();

exports.default = LoginController;


/** WEBPACK FOOTER **
 ** ./src/app/components/user/login.controller.js
 **/